<template>
    <setting-layout :title="$t('pages.user.setting.creator.withdraw_options.withdraw.crypto_wallet.title')">
        <v-container>
            <v-form>
                <v-row v-for="(item, i) in fields" :key="i">
                    <v-col>
                        <div class="pb-1" :class="{'error--text': errors[item.field_name]}">{{ item.label }}</div>
                        <text-field v-if='item.type==="text"'
                                    :placeholder="item.placeholder"
                                    :error-messages="errors[item.field_name]"
                                    v-model="model[item.field_name]"/>
                        <v-select
                            v-else
                            background-color="rgba(237,237,237, .1)"
                            color="orange"
                            :items="item.items"
                            :placeholder="item.placeholder"
                            solo
                            flat
                            item-color="orange"
                            item-text="text"
                            item-value="val"
                            v-model="model[item.field_name]"
                            hide-details


                        >
                        <!-- Custom template for each item -->
                        <template v-slot:item="data">
                            <crypto-currency-icon :icon="data.item.val" class="mr-2" v-if="item.field_name === 'crypto_currency'" />
                            {{ data.item.text }}
                        </template>

                        <template v-slot:selection="data">
                            <crypto-currency-icon :icon="data.item.val" class="mr-2" v-if="item.field_name == 'crypto_currency'" />
                            <v-list-item-content> {{ data.item.text }} </v-list-item-content>
                        </template>
                    </v-select>
                    </v-col>
                </v-row>
                
                <bottom-control-block :checked="defaultBankTransfer"
                                      days-receive="1"
                                      max-days-receive="10"
                                      min-payment="50"
                                      :processing-fee="2.5"
                                      :is-crypto="true"
                                      @change="changeDefault"
                                      :loading="$store.getters.loadingBtn(['setting', 'withdraw', 'directBtn'])"
                                      @done="save">
                </bottom-control-block>

            </v-form>

        </v-container>

        <WithdrawalFormErrorDialog
            v-if="this.isShowWithdrawFormErrorDialog"
            @close="handleCloseWithdrawErrorFormDialog"
        >
            <template #title>
                {{ $t('dialogs.withdrawal_form_error.crypto_wallet.title') }}
            </template>

            <template #description>
                {{ $t('dialogs.withdrawal_form_error.crypto_wallet.description') }}
            </template>
        </WithdrawalFormErrorDialog>
    </setting-layout>
</template>

<script>
import SettingLayout from "@/layouts/app/profile/SettingLayout";
import TextField from "@/components/app/form/TextField";
import countriesSelect from '@/configs/countriesSelect';
import cryptoCurrencies from '@/configs/cryptoCurrencies';
import BottomControlBlock from "@/components/creator/BottomControlBlock";
import { mapActions, mapMutations } from "vuex";
import AccessCameraDialog from "@/components/app/dialogs/AccessCameraDialog.vue";
import WithdrawalFormErrorDialog from "@/components/app/dialogs/WithdrawalFormError.vue";
import CryptoCurrencyIcon from "@/components/app/common/CryptoCurrencyIcon";

export default {
    name: "CryptoWallet",
    data() {
        return {
            success: {},
            errors: {},
            model: {},
            defaultBankTransfer: this.$store.state.user.user.data.withdrawDefault === 'crypto_wallet',
            isShowWithdrawFormErrorDialog: false,
        }
    },
    computed: {
        fields() {
            return [
                {type: 'select', placeholder: this.$t('pages.user.setting.creator.withdraw_options.withdraw.crypto_wallet.placeholder_country'), label: this.$t('pages.user.setting.creator.withdraw_options.withdraw.crypto_wallet.country'), items: countriesSelect, field_name: 'country'},
                {type: 'select', placeholder: this.$t('pages.user.setting.creator.withdraw_options.withdraw.crypto_wallet.placeholder_crypto_currency'), label: this.$t('pages.user.setting.creator.withdraw_options.withdraw.crypto_wallet.crypto_currency'), items: this.cryptoItems, field_name: 'crypto_currency'},
                {type: 'text', placeholder: this.$t('pages.user.setting.creator.withdraw_options.withdraw.crypto_wallet.placeholder_wallet_address'), label: this.$t('pages.user.setting.creator.withdraw_options.withdraw.crypto_wallet.wallet_address'), field_name: 'wallet_address'},
            ]
        },
        cryptoItems() {
            return Object.keys(cryptoCurrencies).map((name) => ({
                text: `${name} (${cryptoCurrencies[name]})`,
                val: cryptoCurrencies[name],
            }));
        },
    },
    methods: {
        changeDefault() {
            this.defaultBankTransfer = !this.defaultBankTransfer
            this.$store.state.user.user.data.withdrawDefault = this.defaultBankTransfer ? 'crypto_wallet' : null
        },
        validateForm(form) {
            for (const key in form) {
                if (form.hasOwnProperty(key)) {
                    const value = form[key]
                    if (value === null || value === undefined || value === '') {
                        console.log(key)
                        return false
                    }
                }
            }
            return true
        },
        save() {
            const isValid = this.validateForm(this.model);
            if (!isValid) {
                this.isShowWithdrawFormErrorDialog = true;
                return;
            }

            this.model.default = this.defaultBankTransfer
            this.sendCryptoWallet({model: this.model})
                .then((result) => {
                    this.success = result || {}
                    this.errors = {}
                    this.showSnackBar(this.$t("dialogs.payment_method.saved"));
                }, (error) => {
                    this.errors = error.response.data.errors || {}
                    this.showSnackBar(this.$t("dialogs.payment_method.not_saved"));
                })
        },
        handleCloseWithdrawErrorFormDialog() {
            this.isShowWithdrawFormErrorDialog = false
        },
        ...mapMutations(["showSnackBar"]),
        ...mapActions([
            'sendCryptoWallet',
            'getCryptoWallet',
        ]),
    },
    mounted() {
        this.getCryptoWallet().then((response) => {
            this.model = response.data || {}
        })
    },
    components: {
        WithdrawalFormErrorDialog,
        AccessCameraDialog,
        BottomControlBlock,
        TextField,
        SettingLayout,
        CryptoCurrencyIcon,
    }
}
</script>

<style scoped>

</style>
